import styled from 'styled-components/macro';
import { Overlay } from '@yme/atoms/overlay';
import { colorCoreBlack900Base, colorCoreGray400, colorCoreGray500, colorCoreWhite1000, } from '@yme/tokens/colors';
import { elevationTopLvl4 } from '@yme/tokens/elevations';
import { ADAPTIVE } from '@yme/tokens/screen';
import { Z_INDEX } from '@yme/tokens/zindex';
import { ellipsisEndingLine, getTextStyles } from '@yme/utils/styles';
import { ANIMATION_TRANSITION_DURATION, MAX_HEIGHT_DEFAULT, MAX_HEIGHT_WITH_COLUM_FOOTER, MAX_HEIGHT_WITH_FOOTER, MAX_HEIGHT_WITH_TITLE, MAX_HEIGHT_WITH_TITLE_AND_COLUM_FOOTER, MAX_HEIGHT_WITH_TITLE_AND_FOOTER, } from './constants';
const getMaxHeightOfModalContent = (titleExist, isVisibleModalWindowFooter, isFooterColumn) => {
    const isTitleAndFooter = titleExist && isVisibleModalWindowFooter;
    const isColumFooter = isVisibleModalWindowFooter && isFooterColumn;
    const map = new Map([
        [isTitleAndFooter && !isFooterColumn, MAX_HEIGHT_WITH_TITLE_AND_FOOTER],
        [isTitleAndFooter && isFooterColumn, MAX_HEIGHT_WITH_TITLE_AND_COLUM_FOOTER],
        [!titleExist && isColumFooter, MAX_HEIGHT_WITH_COLUM_FOOTER],
        [titleExist && !isVisibleModalWindowFooter, MAX_HEIGHT_WITH_TITLE],
        [!titleExist && isVisibleModalWindowFooter && !isColumFooter, MAX_HEIGHT_WITH_FOOTER],
        [!titleExist && !isVisibleModalWindowFooter && !isFooterColumn, MAX_HEIGHT_DEFAULT],
    ]);
    return map.get(true);
};
export const MobileDropdownSliderStyled = styled.div `
  transition: all ${ANIMATION_TRANSITION_DURATION}ms linear;
  height: auto;
  position: fixed;
  box-sizing: border-box;
  left: 0;
  width: 100%;
  border-radius: 8px 8px 0 0;
  user-select: none;
  background-color: ${colorCoreWhite1000};
  z-index: ${Z_INDEX.popupLevel1};

  ${({ isActive }) => isActive && `box-shadow: ${elevationTopLvl4};`}

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  &::-webkit-scrollbar {
    display: none;
  }

  transform: ${({ isActive }) => {
    if (isActive) {
        return 'translate(0, 0)';
    }
    return 'translate(0, 100%)';
}};

  bottom: 0;
`;
export const MobileDropdownHeaderStyled = styled.div `
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0;

  &::after {
    content: '';
    width: 32px;
    height: 4px;
    border-radius: 4px;
    background-color: ${colorCoreGray400};
  }
`;
export const MobileDropdownContentStyled = styled.div `
  padding: ${({ titleExist }) => (titleExist ? '16px' : '8px 16px 16px')};
  padding: ${({ isResetContentPadding }) => isResetContentPadding && 0};
  overflow-y: auto;

  color: ${colorCoreBlack900Base};

  max-height: ${({ titleExist, isVisibleModalWindowFooter, isFooterColumn, maxHeight }) => maxHeight ||
    getMaxHeightOfModalContent(titleExist, isVisibleModalWindowFooter, isFooterColumn)};

  ${ADAPTIVE.minWidth.tablet} {
    padding: ${({ titleExist }) => (titleExist ? '16px 24px' : '8px 24px 16px')};
    padding: ${({ isResetContentPadding }) => isResetContentPadding && 0};
  }
`;
export const MobileSliderContainerStyled = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
`;
export const MobileSliderTitle = styled.div `
  padding: 8px 16px 12px;
  box-shadow: 0 1px 0 ${colorCoreGray500};

  ${ellipsisEndingLine};

  color: ${colorCoreBlack900Base};

  ${ADAPTIVE.minWidth.tablet} {
    padding-left: 24px;
    padding-right: 24px;
  }
`;
export const TitleTextStyled = styled.span `
  ${getTextStyles('Ubuntu', 500, 18, 28)}
`;
export const OverlayStyled = styled(Overlay) `
  display: ${({ isActive }) => (isActive ? 'block' : 'none')};
  bottom: 0;
  max-height: 100vh;
  height: 100vh;
  top: auto;
`;
